import { sendPubSubEvent } from '../api';

export const pathVisited = async (path = {}, domain) => {
  if (!path) {
    return;
  }
  await sendPubSubEvent('user.visited.path', {
    id: path._id,
    title: path.title,
    domain,
  });
};
